var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-notification-panel-item"},[_c('span',{staticClass:"c-count"},[_vm._v(_vm._s(_vm.item.count))]),_c(_setup.NotificationPanelItemLabel,{attrs:{"type":_vm.item.countType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }